import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/less_than_black.svg'
import _imports_1 from '@/assets/images/download_button.svg'


const _hoisted_1 = { class: "all-entries-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "all-entries-title-text h5" }
const _hoisted_4 = { class: "all-entries-info-selector" }
const _hoisted_5 = { class: "all-entries-month-selector" }
const _hoisted_6 = {
  key: 0,
  class: "download-all-month-entries-button"
}
const _hoisted_7 = { class: "all-entries-total-hours h4" }
const _hoisted_8 = { class: "all-entries-my-activities-text medium-text-bold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "all-entries-divider" }, null, -1)
const _hoisted_10 = { class: "all-entry-block-titles" }
const _hoisted_11 = { class: "medium-text role-header" }
const _hoisted_12 = { class: "medium-text objective-header" }
const _hoisted_13 = { class: "medium-text activity-header" }
const _hoisted_14 = { class: "medium-text time-header" }
const _hoisted_15 = { class: "all-entry-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_admin_dropdown = _resolveComponent("admin-dropdown")!
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_task_item_header = _resolveComponent("task-item-header")!
  const _component_time_entry_info_item = _resolveComponent("time-entry-info-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "all-entries-back-button small-text-grey",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leavePage()))
    }, [
      _hoisted_2,
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("component-new-task-view.back")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("component-all-entries-view.all-activities")), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Datepicker, {
          modelValue: _ctx.month,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.month) = $event)),
          monthPicker: "",
          autoApply: "",
          maxDate: new Date(),
          format: 'MMMM yyyy',
          onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getDateValue(_ctx.month))),
          yearRange: [_ctx.minYear, _ctx.currentYear]
        }, null, 8, ["modelValue", "maxDate", "yearRange"])
      ]),
      (_ctx.isAdmin)
        ? (_openBlock(), _createBlock(_component_admin_dropdown, {
            key: 0,
            onSelectUser: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getDateValue(_ctx.month)))
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_tooltip, {
        class: "download-all-month-entries-button-tooltip",
        positionFromTop: 'medium',
        text: _ctx.downloadButtonText
      }, {
        default: _withCtx(() => [
          (_ctx.entriesByDate.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: _imports_1,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadMonthlyEntries(_ctx.month)))
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["text"])
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.displayedTotalTime), 1),
    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("component-all-entries-view.my-activities")), 1),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("component-all-entries-view.role")), 1),
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("component-all-entries-view.objective")), 1),
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("component-all-entries-view.activity")), 1),
      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("component-all-entries-view.time")), 1)
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDate, (mapInfo, indexTwo) => {
        return (_openBlock(), _createElementBlock("div", { key: indexTwo }, [
          _createVNode(_component_task_item_header, {
            taskDate: indexTwo,
            infoDate: ""
          }, null, 8, ["taskDate"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mapInfo, (entry, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "time-entry-info-item",
              key: index
            }, [
              _createVNode(_component_time_entry_info_item, {
                taskInfo: entry,
                allEntryView: true,
                onViewFromAllEntries: ($event: any) => (_ctx.viewEntryInfo(entry))
              }, null, 8, ["taskInfo", "onViewFromAllEntries"])
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}